import icon from "./firstvet icon.png"
import logo from "./firstvet.png"

const firstVet = {
  icon,
  logo,
}

export default firstVet
